import {Component, inject, input} from '@angular/core';
import {OfficeSystemAccordionComponent} from '../components/office-system-accordion/office-system-accordion.component';
import {LoadingComponent} from '../../../../../../../shared/components/loading/loading.component';
import {rxResource} from '@angular/core/rxjs-interop';
import {OfficeSystemRecordingToolsResponse} from '@frontend/shared';
import {DirectusService} from '@frontend/directus';

@Component({
  selector: 'app-step-3-1-system-overview',
  imports: [OfficeSystemAccordionComponent, LoadingComponent],
  templateUrl: './step-3-1-system-overview.component.html',
})
export class Step31SystemOverviewComponent {
  private readonly directusService = inject(DirectusService);
  officeSystemRecording = input.required<OfficeSystemRecordingToolsResponse>();

  protected readonly moduleFunctionsResource = rxResource({
    stream: () => this.directusService.loadModuleFunctions(),
  });
}
